/**
 * Call after Vue/React mounts. Waits for web fonts, then reveals the splash.
 */
export function revealAfterSpaMount() {
    if (typeof window === 'undefined' || typeof window.__appReveal !== 'function') {
        return;
    }

    const fontsReady = (document.fonts && document.fonts.ready) || Promise.resolve();
    Promise.resolve(fontsReady).finally(() => {
        requestAnimationFrame(() => window.__appReveal());
    });
}
